import React, { useState, useEffect, useRef } from 'react';

// Placeholder FAQ data - replace with Strapi API call
const PLACEHOLDER_FAQS = [
	{
		id: 1,
		attributes: {
			question: 'Cara log masuk',
			answer:
				'<strong>Cara log masuk ke sistem e-Bimbingan Haji:</strong><br><br>Bagi <strong>Bakal Haji, PEKTA dan Petugas Haji</strong> yang telah membuat login kali pertama, sila masukkan email, No Pendaftaran Haji atau No PEKTA pada ruangan Nama Pengguna dan Kata Laluan pada ruangan Kata Laluan.<br><br>Bagi lain-lain pengguna, sila klik butang <strong>"Log masuk sebagai pelawat"</strong> untuk melayari sistem e-Bimbingan Haji.',
			is_popular: true,
			keyword: [
				{ id: 1, keyword: 'cara log masuk' },
				{ id: 2, keyword: 'cara login' },
				{ id: 3, keyword: 'how to login' },
				{ id: 4, keyword: 'login' },
				{ id: 5, keyword: 'sign in' },
				{ id: 6, keyword: 'signin' },
				{ id: 7, keyword: 'how to sign in' },
				{ id: 8, keyword: 'log in' },
				{ id: 9, keyword: 'signing in' },
				{ id: 10, keyword: 'access account' },
				{ id: 11, keyword: 'enter system' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 2,
		attributes: {
			question: 'Log masuk kali pertama',
			answer:
				'<strong>Prosedur log masuk kali pertama ke sistem e-Bimbingan Haji:</strong><br><br>Klik butang <strong>"Log masuk kali pertama"</strong> untuk pergi ke halaman log masuk kali pertama.<br><br>Bagi <strong>Bakal Haji</strong>, sila masukkan No Pendaftaran Haji dan No. Kad Pengenalan.<br><br>Bagi <strong>PEKTA</strong>, sila masukkan No PEKTA dan No. Kad Pengenalan.<br><br>Bagi <strong>Petugas Haji</strong>, sila masukkan email berdaftar dengan Tabung Haji dan No. Kad Pengenalan.',
			is_popular: true,
			keyword: [
				{ id: 12, keyword: 'log masuk kali pertama' },
				{ id: 13, keyword: 'login kali pertama' },
				{ id: 14, keyword: 'first time login' },
				{ id: 15, keyword: 'daftar kali pertama' },
				{ id: 16, keyword: 'first time' },
				{ id: 17, keyword: 'first login' },
				{ id: 18, keyword: 'initial login' },
				{ id: 19, keyword: 'new user' },
				{ id: 20, keyword: 'new account' },
				{ id: 21, keyword: 'first time user' },
				{ id: 22, keyword: 'initial setup' },
				{ id: 23, keyword: 'setup account' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 3,
		attributes: {
			question: 'Siapa perlu log masuk kali pertama?',
			answer:
				'<strong>Pengguna yang perlu membuat log masuk kali pertama:</strong><br><br>Bakal Haji, PEKTA dan Petugas Haji yang belum pernah login ke sistem e-Bimbingan Haji perlu membuat log masuk kali pertama.<br><br>Klik pada butang Log masuk kali pertama untuk memulakan proses.',
			is_popular: true,
			keyword: [
				{ id: 24, keyword: 'siapa perlu log masuk kali pertama' },
				{ id: 25, keyword: 'who needs first login' },
				{ id: 26, keyword: 'who should register' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 4,
		attributes: {
			question:
				'Apa maklumat yang diperlukan untuk log masuk kali pertama Bakal Haji?',
			answer:
				'<strong>Maklumat yang diperlukan untuk log masuk kali pertama sebagai Bakal Haji:</strong><br><br>Anda perlu memasukkan:<br><br>• No Pendaftaran Haji pada ruangan Nama Pengguna<br>• No. Kad Pengenalan pada ruangan No. Kad Pengenalan<br><br>Kemudian klik butang Hantar.',
			is_popular: false,
			keyword: [
				{ id: 33, keyword: 'maklumat bakal haji' },
				{ id: 34, keyword: 'bakal haji login' },
				{ id: 35, keyword: 'bakal haji registration' },
				{ id: 36, keyword: 'no pendaftaran bakal haji' },
				{ id: 37, keyword: 'pendaftaran bakal haji' },
				{ id: 38, keyword: 'bakal haji registration info' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 5,
		attributes: {
			question:
				'Apa maklumat yang diperlukan untuk log masuk kali pertama PEKTA?',
			answer:
				'<strong>Maklumat yang diperlukan untuk log masuk kali pertama sebagai PEKTA:</strong><br><br>Anda perlu memasukkan:<br><br>• No PEKTA pada ruangan Nama Pengguna<br>• No. Kad Pengenalan pada ruangan No. Kad Pengenalan<br><br>Kemudian klik butang Hantar.',
			is_popular: false,
			keyword: [
				{ id: 27, keyword: 'maklumat pekta' },
				{ id: 28, keyword: 'pekta login' },
				{ id: 29, keyword: 'pekta registration' },
				{ id: 30, keyword: 'no pekta' },
				{ id: 31, keyword: 'pekta user' },
				{ id: 32, keyword: 'pekta first login' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 6,
		attributes: {
			question:
				'Apa maklumat yang diperlukan untuk log masuk kali pertama Petugas Haji?',
			answer:
				'<strong>Maklumat yang diperlukan untuk log masuk kali pertama sebagai Petugas Haji:</strong><br><br>Anda perlu memasukkan:<br><br>• Email berdaftar dengan Tabung Haji pada ruangan Nama Pengguna<br>• No. Kad Pengenalan pada ruangan No. Kad Pengenalan<br><br>Kemudian klik butang Hantar.',
			is_popular: false,
			keyword: [
				{ id: 39, keyword: 'maklumat petugas haji' },
				{ id: 40, keyword: 'petugas haji login' },
				{ id: 41, keyword: 'petugas haji registration' },
				{ id: 42, keyword: 'petugas haji email' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 7,
		attributes: {
			question: 'Bagaimana cara log masuk sebagai pelawat?',
			answer:
				'<strong>Cara log masuk sebagai pelawat ke sistem e-Bimbingan Haji:</strong><br><br>Bagi lain-lain pengguna yang bukan Bakal Haji, PEKTA atau Petugas Haji, sila klik butang Log masuk sebagai pelawat untuk melayari sistem e-Bimbingan Haji tanpa perlu mendaftar.',
			is_popular: false,
			keyword: [
				{ id: 43, keyword: 'log masuk sebagai pelawat' },
				{ id: 44, keyword: 'login as visitor' },
				{ id: 45, keyword: 'visitor access' },
				{ id: 46, keyword: 'guest login' },
				{ id: 47, keyword: 'public access' },
				{ id: 48, keyword: 'browse without registration' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 8,
		attributes: {
			question: 'Lupa kata laluan',
			answer:
				'<strong>Prosedur untuk reset kata laluan yang terlupa:</strong><br><br>Jika anda lupa kata laluan untuk sistem e-Bimbingan Haji:<br><br>1. Klik pada pautan "Lupa Kata Laluan" pada halaman log masuk<br>2. Masukkan email atau nombor pendaftaran anda<br>3. Ikuti arahan yang dihantar ke email anda<br>4. Buat kata laluan baharu yang selamat<br><br>Jika masih menghadapi masalah, sila hubungi bantuan teknikal.',
			is_popular: true,
			keyword: [
				{ id: 49, keyword: 'lupa kata laluan' },
				{ id: 50, keyword: 'lupa password' },
				{ id: 51, keyword: 'reset password' },
				{ id: 52, keyword: 'forgot password' },
				{ id: 53, keyword: 'password' },
				{ id: 54, keyword: 'forgot' },
				{ id: 55, keyword: 'reset' },
				{ id: 56, keyword: 'lost password' },
				{ id: 57, keyword: 'change password' },
				{ id: 59, keyword: 'password reset' },
				{ id: 58, keyword: 'password recovery' },
				{ id: 60, keyword: 'recover password' },
				{ id: 61, keyword: 'kemaskini kata laluan' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
	{
		id: 9,
		attributes: {
			question: 'Bantuan teknikal',
			answer:
				'<strong>Maklumat bantuan teknikal untuk sistem e-Bimbingan Haji:</strong><br><br>Untuk bantuan teknikal sistem e-Bimbingan Haji:<br><br>• <strong>Emel:</strong> bantuan@tabunghaji.gov.my<br>• <strong>Telefon:</strong> 03-6207 1919<br>• <strong>Waktu Operasi:</strong> Isnin - Jumaat, 8:30 pagi - 5:30 petang<br><br>Pastikan anda menyediakan maklumat seperti jenis pengguna (Bakal Haji/PEKTA/Petugas Haji) dan butiran masalah yang dihadapi.',
			is_popular: true,
			keyword: [
				{ id: 62, keyword: 'bantuan teknikal' },
				{ id: 63, keyword: 'technical support' },
				{ id: 64, keyword: 'support' },
				{ id: 65, keyword: 'bantuan' },
				{ id: 66, keyword: 'help' },
				{ id: 67, keyword: 'assistance' },
				{ id: 68, keyword: 'customer service' },
				{ id: 69, keyword: 'contact support' },
				{ id: 70, keyword: 'get help' },
				{ id: 72, keyword: 'customer support' },
				{ id: 71, keyword: 'technical help' },
			],
			suggestion: [],
			categories: {
				data: [
					{
						id: 2,
						attributes: {
							title: 'Support',
							description:
								"Get general help with technical issues, account problems, and general inquiries. Whether you're experiencing errors, need assistance using features, or have questions about your account, our support section is here to guide you.",
						},
					},
				],
			},
		},
	},
	{
		id: 10,
		attributes: {
			question: 'Login Category Fallback Suggestions',
			answer:
				'This is a placeholder FAQ for Login category fallback suggestions',
			is_popular: false,
			keyword: [],
			suggestion: [
				{ id: 1, suggestion: 'Cara log masuk' },
				{ id: 2, suggestion: 'Log masuk kali pertama' },
				{ id: 3, suggestion: 'Lupa kata laluan' },
			],
			categories: {
				data: [
					{
						id: 1,
						attributes: {
							title: 'Login',
							description:
								'Dapatkan panduan langkah demi langkah dan penyelesaian untuk log masuk akaun anda, termasuk log masuk kali pertama, menetapkan semula kata laluan, menyelesaikan masalah log masuk, serta tip untuk memastikan akaun anda selamat',
						},
					},
				],
			},
		},
	},
];

const Chatbot = () => {
	// URL parameter configuration for iframe integration
	const urlParams = new URLSearchParams(window.location.search);
	const showBubble = urlParams.get('bubble') !== 'false';
	const autoOpen = urlParams.get('autoOpen') === 'true';
	const isIframeMode = urlParams.get('iframe') === 'true' || !showBubble;
	const categoryFilter = urlParams.get('category'); // Filter by specific category (can be comma-separated)

	const [isOpen, setIsOpen] = useState(autoOpen || isIframeMode);
	const [allFaqs, setAllFaqs] = useState([]);
	const [popularFaqs, setPopularFaqs] = useState([]);
	const [categoryFallbackSuggestions, setCategoryFallbackSuggestions] =
		useState({});
	const [chatHistory, setChatHistory] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const chatBodyRef = useRef(null);

	// Strapi API configuration: pick URL by host (prod vs staging) when embedded
	// When chatbot is in an iframe from another origin, use ?api=prod or ?api=staging to override
	const getStrapiBaseUrl = () => {
		const apiParam = urlParams.get('api');
		if (apiParam === 'prod') {
			return (
				process.env.REACT_APP_STRAPI_URL_PROD ||
				'https://api-prod.the-learning.net' ||
				process.env.REACT_APP_STRAPI_URL
			);
		}
		if (apiParam === 'staging') {
			return (
				process.env.REACT_APP_STRAPI_URL_STAGING ||
				'https://api-staging.the-learning.net' ||
				process.env.REACT_APP_STRAPI_URL

			);
		}
		return process.env.REACT_APP_STRAPI_URL;
	};
	const STRAPI_API_URL = getStrapiBaseUrl();
	// Build API endpoint with configurable parameters
	const buildApiEndpoint = () => {
		// Ensure proper URL construction without double slashes
		const cleanBaseUrl = STRAPI_API_URL?.endsWith('/')
			? STRAPI_API_URL.slice(0, -1)
			: STRAPI_API_URL;
		const baseUrl = `${cleanBaseUrl}/api/faqs`;
		const params = new URLSearchParams();

		// Always populate these relations
		params.append('populate[0]', 'keyword');
		params.append('populate[1]', 'suggestion');
		params.append('populate[2]', 'categories');

		// Add category filter ONLY if specified
		if (categoryFilter && categoryFilter.trim()) {
			const categories = categoryFilter.split(',').map((cat) => cat.trim());
			categories.forEach((cat) => {
				// Filter by category title instead of ID
				params.append('filters[categories][title][$in][]', cat);
			});
		}

		// Add sorting (popular FAQs first, then alphabetically by question)
		params.append('sort', 'is_popular:desc,question:asc');

		// Get 25 FAQS, may increase in the future
		params.append('pagination[pageSize]', '25');

		return `${baseUrl}?${params.toString()}`;
	};

	const FAQS_ENDPOINT = buildApiEndpoint();

	// Fetch FAQs from Strapi or use placeholder data
	const fetchFaqs = async () => {
		setIsLoading(true);
		try {
			const response = await fetch(FAQS_ENDPOINT);
			if (response.ok) {
				const data = await response.json();
				setAllFaqs(data.data || []);
				setPopularFaqs(
					(data.data || []).filter((faq) => faq.attributes.is_popular)
				);

				// Extract suggestions from special fallback FAQs by category
				const extractedSuggestions = {};
				(data.data || []).forEach((faq) => {
					const suggestions = faq.attributes.suggestion;
					const categories = faq.attributes.categories;

					// Look for special fallback FAQ with suggestions
					if (
						Array.isArray(suggestions) &&
						suggestions.length > 0 &&
						categories &&
						categories.data
					) {
						// Extract suggestion text from objects
						const suggestionTexts = suggestions.map((s) => s.suggestion);

						// Get category titles
						categories.data.forEach((category) => {
							const categoryTitle = category.attributes.title;
							extractedSuggestions[categoryTitle] = suggestionTexts;
						});
					}
				});
				setCategoryFallbackSuggestions(extractedSuggestions);
			} else {
				throw new Error('Strapi API not available');
			}
		} catch (error) {
			console.warn('Using placeholder data:', error.message);
			// Fallback to placeholder data
			setAllFaqs(PLACEHOLDER_FAQS);
			setPopularFaqs(
				PLACEHOLDER_FAQS.filter((faq) => faq.attributes.is_popular)
			);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchFaqs();
	}, []);

	// Auto-show welcome message for iframe mode
	useEffect(() => {
		if (isIframeMode && chatHistory.length === 0 && !isLoading) {
			setChatHistory([
				{
					type: 'bot',
					content:
						'Hai! Saya di sini untuk membantu anda dengan soalan lazim. Anda boleh taip soalan anda atau klik pada salah satu soalan popular di bawah.',
					timestamp: new Date().toLocaleTimeString(),
				},
			]);
		}
	}, [isIframeMode, chatHistory.length, isLoading]);

	// Scroll to bottom of chat
	useEffect(() => {
		if (chatBodyRef.current) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [chatHistory]);

	// Search FAQs with case-insensitive includes match and keyword mapping
	const searchFaqs = (query) => {
		const searchTerm = query.toLowerCase().trim();

		// First, try to match using backend keywords (if available)
		for (const faq of allFaqs) {
			if (faq.attributes.keyword && Array.isArray(faq.attributes.keyword)) {
				const keywords = faq.attributes.keyword.map((k) =>
					k.keyword.toLowerCase()
				);

				// Check for exact matches first (highest priority)
				const exactMatch = keywords.some(
					(keyword) => searchTerm === keyword || keyword === searchTerm
				);
				if (exactMatch) {
					return faq;
				}

				// Check for phrase matches with higher threshold for multi-word searches
				const phraseMatch = keywords.some((keyword) => {
					// For multi-word searches like "log masuk kali pertama", be very strict
					if (searchTerm.split(/\s+/).length >= 3) {
						// Require the keyword to be a significant part of the search term
						// or the search term to be a significant part of the keyword
						if (searchTerm.includes(keyword) && keyword.length >= 8)
							return true;
						if (keyword.includes(searchTerm) && searchTerm.length >= 8)
							return true;

						// For word-by-word matching, require at least 3 matching words
						const searchWords = searchTerm
							.split(/\s+/)
							.filter((word) => word.length > 2);
						const keywordWords = keyword
							.split(/\s+/)
							.filter((word) => word.length > 2);

						if (searchWords.length >= 3 && keywordWords.length >= 2) {
							const matchingWords = searchWords.filter((word) =>
								keywordWords.some(
									(kw) => kw === word || kw.includes(word) || word.includes(kw)
								)
							);
							// Require at least 3 matching words for longer searches
							return matchingWords.length >= 3;
						}
					} else {
						// For shorter searches, use direct phrase matching
						if (searchTerm.includes(keyword) && keyword.length > 3) return true;
						if (keyword.includes(searchTerm) && searchTerm.length > 3)
							return true;
					}

					return false;
				});

				if (phraseMatch) {
					return faq;
				}
			}
		}

		// Fallback to frontend keyword mapping if backend keywords are not available
		const keywordMap = {
			'maklumat pendaftaran': [
				// Malay keywords
				'maklumat pendaftaran',
				'pendaftaran',
				'daftar',
				'register',
				'registration',
				// English keywords
				'registration info',
				'registration information',
				'sign up',
				'signup',
				'enroll',
				// Common variations
				'daftar',
				'register',
				'enrollment',
				'enrolment',
			],
			'lupa kata laluan': [
				// Malay keywords
				'lupa kata laluan',
				'lupa password',
				'reset password',
				'forgot password',
				// English keywords
				'password',
				'forgot',
				'reset',
				'lost password',
				'change password',
				// Common variations
				'password reset',
				'password recovery',
				'recover password',
				'reset password',
			],
			'log masuk kali pertama': [
				// Malay keywords - more specific to avoid conflicts
				'log masuk kali pertama',
				'login kali pertama',
				'first time login',
				'daftar kali pertama',
				'first time user',
				'initial login',
				// English keywords
				'first time',
				'first login',
				'new user',
				'new account',
				// Common variations
				'initial setup',
				'setup account',
			],
			'cara log masuk': [
				// Malay keywords - more specific to avoid conflicts
				'cara log masuk',
				'cara login',
				'how to login',
				// English keywords - removed generic 'login' to avoid conflicts
				'sign in',
				'signin',
				'how to sign in',
				'how to login',
				// Common variations
				'log in',
				'signing in',
				'access account',
				'enter system',
			],
			'bantuan teknikal': [
				// Malay keywords
				'bantuan teknikal',
				'technical support',
				'support',
				'bantuan',
				'help',
				// English keywords
				'help',
				'support',
				'technical',
				'assistance',
				'customer service',
				// Common variations
				'technical help',
				'customer support',
				'get help',
				'contact support',
			],
		};

		// Check if search term matches any keyword mappings
		for (const [key, keywords] of Object.entries(keywordMap)) {
			if (keywords.some((keyword) => searchTerm.includes(keyword))) {
				const matchedFaq = allFaqs.find((faq) =>
					faq.attributes.question.toLowerCase().includes(key)
				);
				if (matchedFaq) return matchedFaq;
			}
		}

		// Additional direct keyword matching for common English terms
		const directKeywordMap = {
			password: 'lupa kata laluan',
			// Removed generic 'login' to avoid conflicts with 'log masuk kali pertama'
			register: 'maklumat pendaftaran',
			help: 'bantuan teknikal',
			support: 'bantuan teknikal',
			'first time': 'log masuk kali pertama',
			forgot: 'lupa kata laluan',
			reset: 'lupa kata laluan',
			'sign in': 'cara log masuk',
			'sign up': 'maklumat pendaftaran',
			technical: 'bantuan teknikal',
			assistance: 'bantuan teknikal',
		};

		// Check direct keyword matches
		for (const [englishKeyword, malayQuestion] of Object.entries(
			directKeywordMap
		)) {
			if (searchTerm.includes(englishKeyword)) {
				const matchedFaq = allFaqs.find((faq) =>
					faq.attributes.question.toLowerCase().includes(malayQuestion)
				);
				if (matchedFaq) return matchedFaq;
			}
		}

		// Enhanced fallback search with partial word matching
		const searchWords = searchTerm
			.split(/\s+/)
			.filter((word) => word.length > 2);

		// Find FAQ with highest word match score
		let bestMatch = null;
		let bestScore = 0;

		for (const faq of allFaqs) {
			const questionLower = faq.attributes.question.toLowerCase();
			const answerLower = faq.attributes.answer.toLowerCase();

			let score = 0;
			searchWords.forEach((word) => {
				if (questionLower.includes(word)) score += 2; // Question matches are more important
				if (answerLower.includes(word)) score += 1;
			});

			if (score > bestScore) {
				bestScore = score;
				bestMatch = faq;
			}
		}

		// Return best match if score is reasonable (at least 2 points)
		return bestScore >= 2 ? bestMatch : null;
	};

	// Generate fallback message with suggestions
	const generateFallbackMessage = () => {
		let fallbackMessage =
			'Maaf, saya tidak dapat mencari jawapan untuk soalan anda.';

		// Add suggestions from Strapi by category
		const categoryEntries = Object.entries(categoryFallbackSuggestions);
		if (categoryEntries.length > 0) {
			fallbackMessage +=
				'<br><br><strong>Anda boleh cuba soalan-soalan berikut:</strong><br>';

			categoryEntries.forEach(([categoryTitle, suggestions], index) => {
				// Add category title
				fallbackMessage += `<br><strong>${categoryTitle}:</strong><br>`;

				// Add suggestions as bullet points
				suggestions.forEach((suggestion) => {
					fallbackMessage += `• ${suggestion}<br>`;
				});
			});
		} else {
			// Fallback to general suggestions if no suggestions found
			fallbackMessage +=
				'<br><br>• Lupa kata laluan<br>• Log masuk kali pertama<br>• Cara log masuk<br>• Bantuan teknikal';
		}

		return fallbackMessage;
	};

	// Handle user input submission
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!inputValue.trim()) return;

		const userMessage = {
			type: 'user',
			content: inputValue,
			timestamp: new Date().toLocaleTimeString(),
		};

		setChatHistory((prev) => [...prev, userMessage]);

		// Search for matching FAQ
		const matchedFaq = searchFaqs(inputValue);

		// Generate fallback message with all category suggestions
		const fallbackMessage = generateFallbackMessage();

		const botResponse = {
			type: 'bot',
			content: matchedFaq ? matchedFaq.attributes.answer : fallbackMessage,
			timestamp: new Date().toLocaleTimeString(),
			matchedQuestion: matchedFaq ? matchedFaq.attributes.question : null,
		};

		setTimeout(() => {
			setChatHistory((prev) => [...prev, botResponse]);
		}, 500);

		setInputValue('');
	};

	// Handle popular question click
	const handlePopularQuestionClick = (question) => {
		const userMessage = {
			type: 'user',
			content: question,
			timestamp: new Date().toLocaleTimeString(),
		};

		setChatHistory((prev) => [...prev, userMessage]);

		const matchedFaq = allFaqs.find(
			(faq) => faq.attributes.question === question
		);

		const botResponse = {
			type: 'bot',
			content: matchedFaq.attributes.answer,
			timestamp: new Date().toLocaleTimeString(),
			matchedQuestion: question,
		};

		setTimeout(() => {
			setChatHistory((prev) => [...prev, botResponse]);
		}, 300);
	};

	// Toggle chatbot
	const toggleChatbot = () => {
		setIsOpen(!isOpen);
		if (!isOpen && chatHistory.length === 0) {
			// Welcome message
			setChatHistory([
				{
					type: 'bot',
					content:
						'Hai! Saya di sini untuk membantu anda dengan soalan lazim. Anda boleh taip soalan anda atau klik pada salah satu soalan popular di bawah.',
					timestamp: new Date().toLocaleTimeString(),
				},
			]);
		}
	};

	return (
		<>
			{/* Floating Chat Bubble - Only show if not in iframe mode */}
			{showBubble && (
				<div
					className={`chat-bubble ${isOpen ? 'chat-bubble-open' : ''}`}
					onClick={toggleChatbot}
				>
					{isOpen ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18 6L6 18M6 6L18 18"
								stroke="white"
								strokeWidth="2"
								strokeLinecap="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8 12H16M8 8H16M8 16H12M21 12C21 16.9706 16.9706 21 12 21C10.2 21 8.5 20.5 7.1 19.6L3 21L4.4 16.9C3.5 15.5 3 13.8 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
								stroke="white"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</div>
			)}

			{/* Chat Window */}
			{(isOpen || isIframeMode) && (
				<div className={`chat-window ${isIframeMode ? 'iframe-mode' : ''}`}>
					<div className="chat-header">
						<h3>Hajibot</h3>
						<div className="chat-status">
							{isLoading ? 'Loading...' : 'Online'}
						</div>
					</div>

					<div className="chat-body" ref={chatBodyRef}>
						{/* Chat History */}
						{chatHistory.map((message, index) => (
							<div key={index} className={`message ${message.type}`}>
								<div
									className="message-content"
									dangerouslySetInnerHTML={{ __html: message.content }}
								/>
								<div className="message-time">{message.timestamp}</div>
							</div>
						))}
					</div>

					{/* Popular Questions - Always visible above input */}
					{popularFaqs.length > 0 && (
						<div className="popular-questions-horizontal">
							<div className="popular-questions-title">Popular Questions:</div>
							<div className="popular-questions-scroll">
								{popularFaqs.map((faq) => (
									<button
										key={faq.id}
										className="popular-question-btn-horizontal"
										onClick={() =>
											handlePopularQuestionClick(faq.attributes.question)
										}
										title={faq.attributes.question}
									>
										{faq.attributes.question}
									</button>
								))}
							</div>
						</div>
					)}

					<div className="chat-footer">
						<form onSubmit={handleSubmit} className="chat-input-form">
							<input
								type="text"
								value={inputValue}
								onChange={(e) => setInputValue(e.target.value)}
								placeholder="Type your question here..."
								className="chat-input"
								disabled={isLoading}
							/>
							<button
								type="submit"
								className="chat-send-btn"
								disabled={isLoading || !inputValue.trim()}
							>
								<svg
									width="20"
									height="20"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
						</form>
					</div>

					{/* Full-window loading overlay */}
					{isLoading && (
						<div className="chat-loading-overlay">
							<div className="spinner" />
							<div className="loading-text">
								Loading...<span className="loading-dots"></span>
							</div>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default Chatbot;
